<script setup lang="ts"></script>

<template>
  <ContentBlock variant="white">
    <article class="space-y-6">
      <div class="flex flex-col gap-4 md:flex-row">
        <div class="flex w-full flex-col gap-2">
          <div class="h-8 w-full rounded bg-gray-300 md:w-2/3" />
          <div class="h-4 w-1/2 rounded bg-gray-300" />
        </div>
      </div>
      <div class="hidden space-y-3 md:block">
        <div class="h-4 w-full rounded bg-gray-300" />
        <div class="h-4 w-full rounded bg-gray-300" />
        <div class="h-4 w-3/4 rounded bg-gray-300" />
      </div>
      <div class="space-y-5">
        <div class="space-y-2">
          <div class="h-4 w-3/4 rounded bg-gray-300" />
          <div class="h-4 w-1/2 rounded bg-gray-300" />
        </div>
        <div class="space-y-2">
          <div class="h-4 w-3/4 rounded bg-gray-300" />
          <div class="h-4 w-1/2 rounded bg-gray-300" />
        </div>
        <div class="space-y-2">
          <div class="h-4 w-3/4 rounded bg-gray-300" />
          <div class="h-4 w-1/2 rounded bg-gray-300" />
        </div>
        <div class="space-y-2">
          <div class="h-4 w-3/4 rounded bg-gray-300" />
          <div class="h-4 w-1/2 rounded bg-gray-300" />
        </div>
        <div class="space-y-2">
          <div class="h-4 w-3/4 rounded bg-gray-300" />
          <div class="h-4 w-1/2 rounded bg-gray-300" />
        </div>
      </div>

      <div class="flex justify-between border-t pt-6 align-middle text-sm">
        <div class="h-4 w-32 rounded bg-gray-300" />
        <div class="h-4 w-16 rounded bg-gray-300" />
      </div>
    </article>
  </ContentBlock>
</template>
